import { useFormContext } from 'react-hook-form';
import { FormValues } from '.';
import { SelectSimple } from '../../components/Select';

type Props = {
  outputId: string;
};

export function YouTubePrivacyField(props: Props) {
  const outputsForm = useFormContext<FormValues>();

  const privacyStatus = outputsForm.watch(`outputs.${props.outputId}.privacyStatus`);

  return (
    <SelectSimple
      options={
        new Map([
          ['public', 'Public'],
          ['unlisted', 'Unlisted'],
          ['private', 'Private'],
        ])
      }
      label="Privacy status"
      value={privacyStatus}
      onChange={(next) => outputsForm.setValue(`outputs.${props.outputId}.privacyStatus`, next as typeof privacyStatus)}
    />
  );
}
